import { getClientStream } from '@confluence/ssr-data-streaming/entry-points/client.ts';
import { getServerStream } from '@confluence/ssr-data-streaming/entry-points/server.ts';

// This module acts as a live store for streamed SmartLink SSR batch data.
let storeState: Record<string, any> = {};

/**
 * Update the shared store with new batch data.
 * On the server, this also automatically emits the data to the client stream.
 */
export const updateSSRSmartLinksStore = (data: Record<string, any>) => {
	Object.assign(storeState, data);

	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR && window.__SSR_REACT_STREAMING__) {
		const stream = getServerStream('smartlinks');
		if (stream) {
			stream.emit(data);
		}
	}
};

/**
 * Read the latest state from the store.
 */
export const getSSRSmartLinksStore = () => {
	return storeState;
};

// Initialize stream listener at the module level for the browser.
// This ensures we catch all stream pulses as they arrive
// regardless of when the first SmartLink component mounts.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
if (!process.env.REACT_SSR) {
	const stream = getClientStream('smartlinks');
	stream.addListener((batchData: any) => {
		updateSSRSmartLinksStore(batchData);
	});
}

/**
 * Reset the store.
 */
export const resetSSRSmartLinksStore = () => {
	storeState = {};
};
